export enum Locale {
  en = 'en-US'
}
